WiseMetering.Views.NewReport = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',

    events: {
        'change #report-comparison-section': 'showPeriod',
        'change #report-details-section': 'showPeriod',
        'change #report-event-status-section': 'showPeriod',
        'change #report-file-section': 'showPeriod',
        'change #report-folder-section': 'showPeriod',
        'change #report-month': 'onPeriodSpcificsChange',
        'change #report-month-end': 'reportExceptions',
        'change #report-quarter': 'onPeriodSpcificsChange',
        'change #report-period': 'onPeriodChange',
        'change #report-survey-section': 'showPeriod',
        'change #report-year': 'onYearChange',
        'change #report-year-end': 'reportExceptions',
        'change #report-type': 'onTypeChange'
    },

    form_prefix: 'report',

    frequencies: [
        { title: 'Month', value: 'month' },
        { title: 'Quarter', value: 'quarter' },
        { title: 'Year', value: 'year' },
        { title: 'Year to Date', value: 'ytd' }
    ],

    input_readers: [
        { func: $element => $element.val() === '' ? null : $element.val(), type: 'hidden' },
        { func: $element => $element.val() === '' ? null : $element.val(), type: 'select' }
    ],

    template: 'templates/reports/new',

    title: null,

    width: 500,

    eventStatuses: function() {
        return [
            {
                slug: 'all',
                name: i18next.t('common.all')
            },
            {
                slug: 'triggered',
                name: i18next.t('glossary.triggered')
            },
            {
                slug: 'not_triggered',
                name: i18next.t('glossary.not_triggered')
            }
        ];
    },

    eventsReportSettings: function(type) {
        const eventStatusElement = this.$('#report-event-status-section');

        if (['SiteEventsReport', 'OrganizationEventsReport'].includes(type)) {
            eventStatusElement.show();
        } else {
            eventStatusElement.hide();
        }
    },

    folderReportSettings: function(type) {
        const folderElement = this.$('#report-folder-section');
        ['SiteFolderReport'].includes(type) ? folderElement.show() : folderElement.hide();
    },

    getFormData: function() {
        let data = this.formSerializer();
        if (data.folder_id) {
            this.model.unset('site_id');
        } else if (this.options.siteId) {
            delete data.folder_id;
            data.site_id = this.options.siteId;
        } else {
            delete data.folder_id;
            data.organization_id = WiseMetering.currentOrganization.id;
        }

        if (['OrganizationOptimiserReport', 'SiteOptimiserReport', 'SiteSchemaReport', 'SiteMeteringSchemaReport'].includes(data.type)) {
            data.period = 'day';
        }

        if (data.type === 'SiteEsgMultiReport') {
            data.options.file = 'xlsx';
        }

        return data;
    },

    getReportType(type) {
        return WiseMetering.zoneReportTypes.findWhere({ type: type }) || WiseMetering.globalReportTypes.findWhere({ type: type });
    },

    globalDetailedReportSettings: function(type) {
        if (type === 'OrganizationDetailedReport') {
            this.showPeriod();
        }
    },

    globalTagusPark: function(type) {
        if (type === 'OrganizationTagusParkReport') {
            this.showPeriod();
        }
    },

    globalVodafoneSettings: function(type) {
        const fileElement = this.$('#report-file-section');
        type === 'OrganizationVodafoneReport' ? fileElement.show() : fileElement.hide();
    },

    initializeForm: function() {
        this.$('#report-period-section').hide();
        this.$('#report-year-section').hide();
        this.$('#report-month-section').hide();
        this.$('#report-quarter-section').hide();
        this.$('#report-end-section').hide();

        this.$('#report-period').val('');
        this.$('#report-utility-kind').val('');
        this.$('#report-comparison').val('');
        this.$('#report-event-status').val('');
        this.$('#report-file').val('');
        this.$('#report-folder').val('');
        this.$('#report-details').val('');
        this.$('#report-survey').val('');
    },

    iosaException: function() {
    },

    markersReportSettings: function(type) {
        if (type === 'SiteMarkersReport') {
            this.showPeriod();
        }
    },

    month: function(selectedPeriod) {
        let month = 1;

        if (selectedPeriod === 'month') {
            month = parseInt(this.$('#report-month').val());
        } else if (selectedPeriod === 'quarter') {
            month = (parseInt(this.$('#report-quarter').val()) - 1) * 3 + 1;
        }

        return month > 9 ? month : `0${month}`;
    },

    onPeriodChange: function() {
        const selectedPeriod = this.$('#report-period').val();

        ['month', 'quarter', 'year'].forEach(period => {
            this.$(`#report-${period}-section`).hide();
            this.$(`#report-${period}`).val('');
        });

        if (selectedPeriod !== 'ytd') {
            this.$('#report-year-section').show();
        }

        this.onPeriodSpcificsChange();
    },

    onPeriodSpcificsChange: function() {
        const
            selectedPeriod = this.$('#report-period').val(),
            selectedYear = parseInt(this.$('#report-year').val()),
            isCurrentYear = selectedYear === moment().year();

        this.$(`#report-year option[value=${moment().year()}]`).prop('disabled', selectedPeriod === 'year');

        const isSurveyReport = this.$('#report-type').val() === 'SiteSurveyReport';

        ['month', 'quarter'].forEach(period => {
            let currentPeriodValue = period === 'month'
                ? moment().month() + (isSurveyReport ? 1 : 0)
                : moment().quarter() - 1;

            this.$(`#report-${period} option`).each(function(_index, element) {
                if (isCurrentYear ? element.value > currentPeriodValue : element.value) {
                    $(element).prop('disabled', isCurrentYear);
                }
            });

            this.$(`#report-${period}-section`)[selectedPeriod === period ? 'show' : 'hide']();
        });

        let start, finish;
        if (selectedPeriod === 'ytd') {
            start = `${moment().year()}-01-01`;
            finish = moment().subtract(1, 'day').format('YYYY-MM-DD');
        } else {
            start = `${selectedYear}-${this.month(selectedPeriod)}-01`;
            finish = moment(start).endOf(selectedPeriod).format('YYYY-MM-DD');
        }

        this.$('#report-start').val(start);
        this.$('#report-finish').val(finish);

        this.reportExceptions();
    },

    onShow: function() {
        this.$('#report-description-section').hide();
        this.initializeForm();

        let language = WiseMetering.currentOrganization.get('language').toLowerCase();
        this.$(`#report-language > option[value='${language}']`).prop('selected', true);
    },

    onTypeChange: function() {
        const type = this.$('#report-type').val();
        this.initializeForm();
        this.setReportDescription(type);
        this.utilityKindReportSettings(type);
        this.folderReportSettings(type);
        this.markersReportSettings(type);
        this.schemasReportSettings(type);
        this.surveyReportSettings(type);
        this.eventsReportSettings(type);
        this.zoneDetailedReportSettings(type);
        this.optimiserReportSettings(type);
        this.globalDetailedReportSettings(type);

        // Custom Reports
        this.zoneEsgMultiSettings(type);
        this.globalVodafoneSettings(type);
        this.globalTagusPark(type);
        this.reportExceptions();

        // Reset periods
        this.cleanPeriodOptions();
    },

    onYearChange: function() {
        const selectedPeriod = this.$('#report-period').val();

        ['month', 'quarter'].forEach(period => {
            this.$(`#report-${period}-section`).hide();
            this.$(`#report-${period}`).val('');
        });

        this.onPeriodSpcificsChange();
    },

    cleanPeriodOptions: function() {
        this.$('#report-month').val('');
        this.$('#report-quarter').val('');
        this.$('#report-year').val('');
    },

    optimiserReportSettings: function(type) {
        if (type === 'OrganizationOptimiserReport' || type === 'SiteOptimiserReport') {
            this.$('#report-period-section').hide();
            this.$('#report-year-section').hide();
            this.$('#report-month-section').hide();

            let today = moment().format('YYYY-MM-DD');

            this.$('#report-start').val(today);
            this.$('#report-finish').val(today);
        }
    },

    reportExceptions: function() {
        this.iosaException();
    },

    schemasReportSettings: function(type) {
        if (type === 'SiteSchemaReport' || type === 'SiteMeteringSchemaReport') {
            this.$('#report-period-section').hide();
            this.$('#report-year-section').hide();
            this.$('#report-month-section').hide();

            let today = moment().format('YYYY-MM-DD');

            this.$('#report-start').val(today);
            this.$('#report-finish').val(today);
        }
    },

    serializeData: function() {
        const now = moment();

        // the || null is required, because looking for undefined site_id will return 0 results
        const folders = WiseMetering.folders.where({ site_id: this.options.siteId || null }).map(folder => {
            const id = folder.id;
            let
                depth = 0,
                name = folder.get('name'),
                parent = folder.parent();

            while (parent && parent.type() !== 'site') {
                name = `${parent.get('name')} > ${name}`;
                parent = parent.parent();
                depth += 1;
            }
            return { depth, id, name };
        }).sort((a, b) => {
            // make the ones with depth 0 appear first
            if (a.depth === 0 || b.depth === 0) {
                if (a.depth === b.depth) {
                    return a.name > b.name ? 1 : -1;
                }
                return a.depth > b.depth ? 1 : -1;
            } else {
                return a.name > b.name ? 1 : -1;
            }
        });

        let reports = this.options.siteId ? WiseMetering.zoneReportTypes.filterTypes(this.options.siteId) : WiseMetering.globalReportTypes.filterTypes();

        return Object.assign({}, this.model.toJSON(), {
            eventStatuses: this.eventStatuses(),
            folders,
            frequencies: this.frequencies,
            month: now.month(),
            quarter: now.quarter() - 1,
            quarters: [1, 2, 3, 4],
            reports: reports,
            site_id: this.options.siteId,
            utilityKinds: WiseMetering.utilityKinds.map(x => ({ slug: x.get('slug'), name: x.get('name') })),
            year: now.year(),
            years: this.model.reportingYears()
        });
    },

    setReportDescription: function(type) {
        let reportType = this.getReportType(type);
        this.$('#report-description-section').show();
        this.$('#report-description-section').html(reportType.getDescription(type));
    },

    showPeriod: function() {
        this.$('#report-period-section').show();
    },

    surveyReportSettings: function(type) {
        const surveyElement = this.$('#report-survey-section');
        type === 'SiteSurveyReport' ? surveyElement.show() : surveyElement.hide();
    },

    utilityKindReportSettings: function(type) {
        const
            option = this.$('#report-type option:selected').text().trim(),
            comparisonElement = this.$('#report-comparison-section'),
            utilityKindElement = this.$('#report-utility-kind-section'),
            isSingleUtilityKind = option === 'Utility';

        ['SiteUtilityReport', 'OrganizationUtilityReport'].includes(type) ? comparisonElement.show() : comparisonElement.hide();

        isSingleUtilityKind ? utilityKindElement.show() : utilityKindElement.hide();
    },

    zoneDetailedReportSettings: function(type) {
        const detailsElement = this.$('#report-details-section');
        type === 'SiteDetailedReport' ? detailsElement.show() : detailsElement.hide();
    },

    zoneEsgMultiSettings: function(type) {
        if (type === 'SiteEsgMultiReport') {
            this.showPeriod();
        }
    }
});
